module.exports = __webpack_public_path__ + "static/media/holiday.8f97a5fb.jpg";